import { ProjectSetup, Subproject } from '.';

export interface SelectedSubproject extends Subproject {
  data?: ProjectSetup;
}
